import React, {useReducer, useRef, useState} from 'react';
import styles from './styles';
import Cell from './Cell';
import {colors} from '../defaultSettings';
import {ModalContainer} from '@xpertdox_js/xdcomponents';
// import {DragTableContext} from '../Utils/DragTableContext';

const heightReducer = (state, action) => {
  switch(action.type) {
    case 'reset':
    return action.value;
    case 'update':
    let update = state.slice();
    // console.log(action.value, action.index)
    update[action.index] = {
      height: action.value.height || state[action.index].height,
      customHeight: action.value.customHeight !== undefined ? action.value.customHeight : 0,
    };
    return update;
    default:
    return state;
  }
}


const Cells = props => {

  // get distance of drag event
  // const {dragDistance} = React.useContext(DragTableContext);
  const [modal, setModal] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const openModal = (data) => {
    setModal(data)
    setShowModal(true);
  }
  const [heights, setHeights] = useReducer(heightReducer, null,
    () => props.dataKeys ? props.dataKeys.map(() => ({height: 42, customHeight: 0})) : null
  );
  // const [heights, setHeights] = useState(() => props.dataKeys ? props.dataKeys.map(() => 42) : null)
  if (props.dataKeys && heights === null) {
    setHeights({type: 'reset', value: props.dataKeys.map(() => ({height: 42, customHeight: 0}))});
  }

  const pageOffset = props.controller.pageLimit * props.controller.page;
  const updateHeights = (index, value, customValue) => {
    setHeights({type: 'update', index: index, value: {
      height: value,
      customHeight: customValue
    }});
  }
  const listMemo = props.dataKeys ? props.dataKeys.join('') : [];
  const lastList = useRef(null);
  if (props.dataKeys && lastList.current === null) lastList.current = listMemo;
  if (props.dataKeys && listMemo !== lastList.current) {
    // console.log('reset heights')
    setHeights({type: 'reset', value: props.dataKeys.map(() => ({height: 42, customHeight: 0}))});
    lastList.current = listMemo;
  }

  const dragParentStyles = {
    width: props.width,
    marginLeft: '15px',
    overflowX: 'hidden',
    transition: 'width .18s ease-out'
  }
  const dragContentStyles = {
    display: 'inline-block',
    transform: 'translateX(0px)',
    position: 'static',
    minWidth: '100%',
  }
  const lineNumberContainer = {
    position: 'absolute',
    left: 0, top: 0,
    width: '15px',
    height: '100%',
    zIndex: 3,
  }

  const lineNumbers = React.useMemo(() => props.dataKeys
  ? props.dataKeys.map((dataID, i) =>
      <span key={i} style={{...styles.lineNumber, height: heights[i] ? heights[i].height + heights[i].customHeight + 'px' : '42px'}}>
          <span style={styles.lineNumberNumber}>{(props.page * props.controller.pageLimit) + (i + 1)}</span>
      </span>
    )
  : null, [props.dataKeys, heights])

  const cells = React.useMemo(() => props.dataKeys
  ? props.dataKeys.map((dataID, i) => {
      const key = dataID;
      return(
        <Cell
        data={props.data[dataID]}
        key={
          key + props.memo + props.page
          + props.controller.queryString
          + props.controller.sortKey
          + props.controller.registryCount
          + props.controller.globalSearchQuery
        }
        id={key}
        first={i === 0}
        last={i === props.data.length - 1}
        headerSettings={props.headerSettings}
        headers={props.headers}
        hovBg={colors.bg.rowHov}
        even={i % 2 === 0}
        background={i % 2 === 0 ? colors.bg.row0 : colors.bg.row1}
        wrapHeight={heights[i] ? heights[i].height + heights[i].customHeight + 'px' : '42px'}
        dropdown={props.dropdown}
        modal={props.modal}
        setModal={openModal}
        showModal={showModal}
        dataRefresh={props.dataRefresh}
        memo={props.memo}
        page={props.page}
        route={props.route}
        history={props.history}
        location={props.location}
        activeFetchParam={props.activeFetchParam}
        routeSettings={props.routeSettings}
        cellRouteSettings={props.cellRouteSettings}
        actions={props.actions}
        controller={props.controller}
        width={props.width}
        index={i + pageOffset}
        tableIndex={i}
        heights={heights}
        updateHeights={updateHeights}
        userDetails={props.userDetails}
      />
    );
    })
  : null, [props.dataKeys, heights, props.width]);

  return(
    <React.Fragment>
    <div
      style={{
        ...styles.container,
        position: 'relative',
        // marginBottom: `${props.controller.searchingHeader === null ? 48 : 72}px`,
      }}
    >
      <div style={lineNumberContainer} id={props.controller.tableID + '_lineCol'}>
        {lineNumbers}
      </div>
      {props.dataKeys && props.dataKeys.length > 0 &&
        <div style={dragParentStyles}>
          <div style={dragContentStyles} id={props.controller.tableID + '_parent_cells'}>
            {cells}
          </div>
        </div>
      }
      {props.dataKeys && props.dataKeys.length === 0 &&
        <div style={styles.emptyPlaceholder}>
          <div style={styles.emptyContent}>
            <svg style={styles.emptySvg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M346.5 240h-181c-8.8 0-16 6-16 16s7.5 16 16 16h181c8.8 0 16-7.2 16-16s-7.2-16-16-16z"/><path d="M256 76c48.1 0 93.3 18.7 127.3 52.7S436 207.9 436 256s-18.7 93.3-52.7 127.3S304.1 436 256 436c-48.1 0-93.3-18.7-127.3-52.7S76 304.1 76 256s18.7-93.3 52.7-127.3S207.9 76 256 76m0-28C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z"/></svg>
            <p style={styles.emptyTitle}>No Results.</p>
          </div>
        </div>
      }
    </div>
    {modal !== null &&
      <ModalContainer
        open={showModal}
        showOverlay={showModal}
        close={() => setShowModal(false)}
        width={document.body.clientWidth > 1000 ? document.body.clientWidth * .7 : document.body.clientWidth * .9}
        height={window.innerHeight > 800 ? window.innerHeight * .5 : window.innerHeight * .7}
        callback={!showModal ? () => setModal(null) : null}
      >
        <props.modal
          data={modal}
          dataRefresh={props.dataRefresh}
          memo={props.memo}
        />
      </ModalContainer>
    }
    </React.Fragment>
  )
}

export default Cells;
